import React, { useState, useEffect } from 'react';
import { Container, Row, Col, CardBody, Card, Button, Modal, ModalHeader, ModalBody, Popover } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';
import '../OrderCreation/OrderCreation.css';
import CommonService from 'Services/CommonService';
import "../OrderCreation/OrderCreation.css";
import { DecodeParam, getTokenDetail } from 'helpers/helper';
import { HelperConstant, OrderStatus, days, splitDateTime } from 'Components/constants/PandaConstants';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePayment from '../../Payment/StripePayment';
import { ITokenModel } from 'Models/ITokenModel';
import { jwtDecode } from 'jwt-decode';
import PaypalPayment from 'pages/Payment/PaypalPayment';
import { useDispatch } from 'react-redux';
import { pageNameHandler } from 'slices/thunk';
import moment from 'moment';
import { Loader } from 'Components/Loader/Loader';
import momentTz from 'moment-timezone';
import { Radio, TextField } from '@mui/material';
import { CustomToaster } from 'Components/Shared/CustomToaster';
// import ApplePayPayment from 'pages/Payment/ApplePay';

const CourseMenu = () => {
  const { restaurentid, selectedAddressId, menuid, dayId } = useParams();
  let navigate = useNavigate();

  const [menuDetails, setMenuDetails] = useState<Array<{ amount: number; menuName: string; menuitems: Array<string>, menuUploadFilePath: string, encryptedId: any, description: string, countryName: string, cityName: string, stateName: string, zipCodeName: string, deliveryTime: string, quantity: number, remainingCount: number, weeklyMenuCount: number }>>([]);
  const [disabled, setDisabled] = useState(false);
  const [toast, setToast] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [selectPayment, setSelectPayment] = useState(false);
  const [paypalOpen, setPaypalOpen] = useState(false);
  const [stripePromise, setStripePromise] = useState<any>(null);
  const [clientSecret, setClientSecret] = useState('');
  const [isSetupIntent, setIsSetupIntent] = useState(false);
  const [showPaymentElement, setShowPaymentElement] = useState(false);
  const [showStripeElement, setShowStripeElement] = useState(false);
  const [isExistingCard, setIsExistingCard] = useState(false);
  const [showSaveCardPopup, setShowSaveCardPopup] = useState(false);
  const [clientId, setClientId] = useState<any>("");
  const [count, setCount] = useState<number>(1);
  const [selectedMethod, setSelectedMethod] = useState<string>('7CF167E95CFEBEA1E7C39382001017A5');
  const [isPaymentStart, setPaymentStart] = useState<{ paymentProcess: boolean, orderCreation: boolean }>({ paymentProcess: false, orderCreation: false });
  const [isDeliveryDate, setIsDeliveryDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [isOrderCountWarning, setIsOrderCountWarning] = useState(false);
  const [difference, setDifference] = useState(0);
  // const [paymentKey,setPaymentKey] = useState("");
  const [couponCode, setCouponCode] = useState<any>("");
  const [couponCodeMessage, setCouponCodeMessage] = useState<string>("");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [availbleCoupon, setAvailbaleCoupon] = useState<Array<any>>([]);
  const [isOpen, setIsOpen] = useState(false);
  const [appliedCoupon, setAppliedCoupon] = useState<any>();
  const [userId, setUserId] = useState<any>();
  const [vaLidateOfferCode, setValidateOfferCode] = useState<any>();
  const [isApplied, setIsApplied] = useState(false);
  const [discountCalc, setDiscountCalc] = useState<any>();
  const [quantitydiscountCalc, setQuantityCalc] = useState<any>();
  const [isQuantityDiscount, setIsQuantityDiscount] = useState<boolean>(false);
  // const [validMessage, setValidMessage] = useState("");
  const [paymentMethodData, setPaymentMethodData] = useState<any>([]);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState<boolean>(false);
  const [toPayAmount, setToPayAmount] = useState("");
  const [cardDetails, setCardDetails] = useState<any>();
  let token: string = localStorage.getItem("authUser") as string;
  let tokendata: ITokenModel = jwtDecode(token);
  const [selectedCardIndex, setSelectedCardIndex] = useState<any>();
  const [disableCouponText, setDisableCouponText] = useState(false);
  // const validMessage = "Your Coupon Code applied Successfully !";
  const inValidMessage = "Invalid Promo Code";

  document.title = "Order | Panda GoGoGo ";

  const handleClose = () => {
    setIsExistingCard(false);
  };

  const handlePaymentClose = () => {
    setPaypalOpen(!paypalOpen);
    setClientId("");
    setIsPaymentOpen(false);
    setStripePromise(null);
    setShowPaymentElement(false);
    setShowStripeElement(false);
    setLoader(false)
    setSubmitDisabled(false);
  }

  const handleUseCard = (useCard) => {
    setIsExistingCard(useCard);
    setShowSaveCardPopup(true);
  };

  const GetStripePaymentMethods = () => {
    let token = getTokenDetail();
    let amount = quantitydiscountCalc != null && count == quantitydiscountCalc?.numberOfFreeCount ? 0 : parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", "")).toString();
    CommonService.getWithFourParam("Payment", "GetCardDetails", token?.LoginId, amount,menuDetails[0].encryptedId,count).then((res) => {
      if (res.status == 200) {
        setLoader(false);
        setCardDetails(res.data);
        setShowSaveCardPopup(true);
      } else {
        setLoader(false);
        setShowSaveCardPopup(true);
      }
    })
  }

  const payNow = () => {
    if (selectedCardIndex == 'newCard') {
      getStripekey(true, "");
    } else if (selectedCardIndex == 'noSaveCard') {
      getStripekey(false, "");
    } else {
      setIsExistingCard(true);
      getStripekey(false, cardDetails[selectedCardIndex].encryptedCardId);
    }
  }

  const getStripekey = (isSaveCard: boolean, cardId: string) => {
    setLoader(true);
    let decodedId = DecodeParam(restaurentid);
    let data = {
      EncryptedRestaurantId: restaurentid,
      PaymentMethodId: null,
      EncryptedCardId: cardId,
      EncryptedLoginId: tokendata?.LoginId,
      Amount: parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", "")).toString(),
      isSaveCard: isSaveCard,
      IsUseExistingCard: isExistingCard,
      EncryptedMenuId:menuDetails[0].encryptedId,
      quantity:count
    }

    CommonService.post("Payment", "CreatePaymentDetails", data).then((res) => {
      if (res.status == 200) {
        if (res.data) {
          let key = res.data;
          setShowSaveCardPopup(false);
          if (isExistingCard && key.startsWith('pi_')) {
            setIsSetupIntent(false);
            setShowStripeElement(true);
          } else if (isSaveCard && key.startsWith('pi_')) {
            setIsSetupIntent(false);
            setIsExistingCard(false);
            setShowStripeElement(true);
          } else if (key.startsWith('seti_')) {
            setIsSetupIntent(true);
            setIsExistingCard(false);
            setShowStripeElement(true);
          } else {
            setIsSetupIntent(false);
            setShowStripeElement(true);
            setIsExistingCard(false);
          }
          setClientSecret(key);
          loadkeys(restaurentid);
        }
      }
    });
  }

  const loadkeys = (decodedId) => {
    CommonService.getWithQueryParam("Payment", "GetPaymentKey", "restaurantId", decodedId).then(async (res) => {
      if (res.status == 200) {
        if (selectedMethod == '7CF167E95CFEBEA1E7C39382001017A5' && selectedCardIndex != "newCard" && selectedCardIndex != "noSaveCard") {
          CreatePaymentLog("Stripe has been loaded for the payment", OrderStatus.PaymentInProgress, selectedMethod, cardDetails[selectedCardIndex].encryptedCardId, clientSecret);
        } else {
          CreatePaymentLog("Stripe has been loaded for the payment", OrderStatus.PaymentInProgress, selectedMethod, "", clientSecret);
        }
        let data = await loadStripe(res.data.paymentKey ?? "");
        // setPaymentKey(res.data.paymentKey);
        setStripePromise(data);
        setIsPaymentOpen(true);
        togglePaymentType();
        setLoader(false);
      }
    });
  }

  const getPaypalkey = () => {
    CommonService.getWithQueryParam("Restaurent", "GetRestaurentPaymentConfigByUniversityId", "universityId", tokendata.UniversityId).then(async (res) => {
      if (res.status == 200) {
        setClientId(res.data.responseData);
        // setShowPaymentElement(true);
      }
    });
  }

  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(pageNameHandler({ pageName: "Order Summary" }));
  }, []);

  const paymentTypeToggle = () => {
    let amount = discountCalc != null ?
      (((menuDetails[0]?.amount * count) - (menuDetails[0]?.amount * count) * (discountCalc)) +
        ((8.25 / 100) * ((menuDetails[0]?.amount * count) - ((menuDetails[0]?.amount * count) * (discountCalc))))).toFixed(2) :
      quantitydiscountCalc != null && count != quantitydiscountCalc?.numberOfFreeCount ? (((8.25 / 100) * menuDetails[0]?.amount * (count - quantitydiscountCalc?.numberOfFreeCount)) + (menuDetails[0]?.amount * (count - quantitydiscountCalc?.numberOfFreeCount))).toFixed(2) :
        quantitydiscountCalc != null && count != quantitydiscountCalc?.numberOfFreeCount ? 0 :
          (((8.25 / 100) * menuDetails[0]?.amount * count) + (menuDetails[0]?.amount * count)).toFixed(2);
    setToPayAmount(amount.toString());
    setLoader(true);
    setSubmitDisabled(true);
    if (quantitydiscountCalc != null && count == quantitydiscountCalc?.numberOfFreeCount) {
      CreatePaymentLog("User tried to submit the order and it is a free order",OrderStatus.OrderInitiated,"");
      processOrder("", false,0, true);
    } else {
      GetStripePaymentMethods();
      setShowPaymentElement(true);
      getPaypalkey();
      // getStripekey();
    }
    togglePaymentType();
  }

  const CreatePaymentLog = (comments: string, statusId: number, paymentmethodId?: string, cardId?: string, transactionId?: string) => {
    let data = {
      EncryptedUserId: userId,
      EncryptedPaymentMethodId: paymentmethodId !== "" && paymentmethodId != null ? paymentmethodId : selectedMethod,
      EncryptedStripeCardId: cardId !== "" && cardId != null ? cardId : null,
      amount: quantitydiscountCalc != null && count == quantitydiscountCalc?.numberOfFreeCount ? 0 : parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", "")).toString(),
      comments: comments,
      CouponCodeTransactionId: appliedCoupon?.id,
      transactionId: transactionId,
      statusId: statusId,
      EncryptedMenuId:menuDetails ? menuDetails[0].encryptedId : null,
      Quantity :count
    }
    CommonService.post("Payment", "CreatePaymentLog", data).then((res) => {
      if (res.status == 200) {
      }
    })
  }

  const onCancelClick = () => {
    navigate(`/pickup-address/${restaurentid}/${menuid}/${dayId}`);
  }

  const GetPickUpAddress = () => {
    setLoader(true);
    let decodedId = DecodeParam(menuid);
    let decodedDayId = DecodeParam(dayId);
    let decodedPickUpAddressId = DecodeParam(selectedAddressId);
    CommonService.postWithTribalParam("Menu", "GetMenuDetailsByMenuId", "menuId", "dayId", "pickupAddressId", menuid, decodedDayId, selectedAddressId)
      .then(res => {
        if (res.status === 200) {
          setLoader(false);
          // setCount(res.data.responseData[0].quantity)
          res.data.responseData.map((menu, index) => {
            menu.deliveryTime = splitDateTime(menu.deliveryCutOffStartTime, menu.deliveryCutOffEndTime);
          })
          setIsOrderCountWarning(res.data.responseData[0].remainingCount == count ? true : false)
          setMenuDetails(res.data.responseData);
        }
      })
      .catch(e => console.log(e));
  };

  const getPaymentMethods = () => {
    CommonService.get("Masters", "GetPaymentMethodMaster").then((res) => {
      if (res.status == 200) {
        setPaymentMethodData(res.data.responseData.paymentMethodList);
      }
    })
  }

  useEffect(() => {
    let userid = tokendata?.UserId;
    setUserId(userid);
    GetPickUpAddress();
    getPaymentMethods();
    let DecodedDayId = DecodeParam(dayId);
    let day = moment().format('dddd');
    let todayId = days.find(item => item.day == day)?.id;
    let difference;
    if (todayId !== undefined && parseInt(DecodedDayId) < todayId) {
      difference = (7 - todayId) + parseInt(DecodedDayId);
    }
    else if (todayId !== undefined && parseInt(DecodedDayId) > todayId) {
      difference = parseInt(DecodedDayId) - todayId;
    }

    setDifference(difference);
    const momentDate = moment().add(difference, 'day').utc().format('MM-DD-YYYY');
    if (parseInt(DecodedDayId) === todayId) {
      setIsDeliveryDate(moment(new Date().toISOString()).format('MM-DD-YYYY'));
    }
    else {
      setIsDeliveryDate(moment(new Date(new Date().setDate(new Date().getDate() + difference)).toISOString()).format('MM-DD-YYYY'))
    }
  }, [menuid]);


  const processOrder = (Paymentmethodid: string, isToast: boolean, stripeCardId?: any, freeOrder: boolean = false) => {
    if (freeOrder == false) {
      if (selectedMethod == '7CF167E95CFEBEA1E7C39382001017A5' && selectedCardIndex != "newCard" && selectedCardIndex != "noSaveCard") {
        CreatePaymentLog("Order creation API has been triggered", OrderStatus.OrderInitiated, selectedMethod, cardDetails[selectedCardIndex].encryptedCardId, Paymentmethodid);
      } else {
        CreatePaymentLog("Order creation API has been triggered", OrderStatus.OrderInitiated, selectedMethod, "", Paymentmethodid);
      }
    } else {
      CreatePaymentLog("Order creation API has been triggered and it is a free order", OrderStatus.OrderInitiated, "7CF167E95CFEBEA1E7C39382001017A5","", Paymentmethodid);
    }

    setToast(isToast);
    setLoader(true);
    setDisabled(true);
    let token: any = getTokenDetail();
    const subtotal = menuDetails ? menuDetails[0].amount : 0;
    let decodedDayId = DecodeParam(dayId);
    let day = moment().format('dddd');
    let todayId = days.find(item => item.day == day)?.id;
    const userTimezone = momentTz().tz(momentTz.tz.guess()).format('Z');
    const requestBody = {
      EncryptedUserId: token.LoginId,
      UserId: 0,
      isQuantityDiscount: quantitydiscountCalc != null ? true : false,
      // orderDate: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      EncryptedRestaurentId: restaurentid,
      EncryptedPaymentMethodId: selectedMethod,
      transactionId: Paymentmethodid?.toString(),
      Amount: quantitydiscountCalc != null && count == quantitydiscountCalc?.numberOfFreeCount ? 0 : parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", "")).toString(),
      count: count,
      EncryptedPickUpAddressId: selectedAddressId,
      // deliveryDate: decodedDayId == todayId ? new Date().toISOString() : new Date(new Date().setDate(new Date().getDate() + difference)).toISOString(),
      // deliveryDate: decodedDayId == todayId ? moment().utc().format("YYYY-MM-DD HH:mm:ss") : moment().add(difference, 'day').utc().format('YYYY-MM-DD HH:mm:ss'),
      orderMenu: {
        EncryptedMenuId: menuDetails ? menuDetails[0].encryptedId : 0,
        quantity: 1,
        orderMenuItem: [],
      },
      dayId: decodedDayId,
      userTimezone: userTimezone,
      Discount: discountCalc != null ? discountCalc : null,
      SalesTax: HelperConstant.SalesTax / 100,
      CouponCodeTransactionId: appliedCoupon?.id,
      isSetupIntent: isSetupIntent,
      StripCardId: stripeCardId
    };
    CommonService.post("UserOrder", "CreateUserOrder", requestBody).then(res => {
      if (res.status == 200) {
        var routingPath = res.data.responseData as string;
        var ids = routingPath.split(',');
        // var encryptedIds = ids.map(id => EncodeParam(id));
        var encryptedRoutingPath = ids.join('/');
        setLoader(false);
        if (isToast) {
          setTimeout(() => {
            navigate(`/order-summary?${encryptedRoutingPath}`);
          }, 4000);
        } else {
          navigate(`/order-summary?${encryptedRoutingPath}`);
        }
      }
    });
  }

  const togglePaymentType = () => {
    setSelectPayment(!selectPayment);
  }

  const toggleImagePopup = () => {
    setIsImagePopupOpen(!isImagePopupOpen);
  }

  const handleImagePopup = () => {
    setIsImagePopupOpen(true);
  }

  const handleImageClose = () => {
    setIsImagePopupOpen(false);
  }

  const onAddIconClick = () => {
    if (menuDetails[0]?.remainingCount >= menuDetails[0].quantity) {
      if (count < menuDetails[0].quantity) {
        setCount(count + 1);
      }
    } else {
      if (count < menuDetails[0]?.remainingCount && count < menuDetails[0].quantity) {
        setCount(count + 1);
      }
    }
  }

  const checkValidReferralCode = () => {
    CommonService.getWithTripleQueryParam("CouponCode", "GetCouponCodeTransactionByOfferCode", "userId", userId, "offerCode", couponCode, "getDate", moment.utc().format("YYYY-MM-DD HH:mm:ss")).then(res => {
      if (res.status === 200) {
        if (res.data.responseData != "") {
          setDisableCouponText(true);
          setIsApplied(true);
          if (res.data.responseData[0].message == null) {
            if (res.data.responseData[0].couponTypeId == 1) {
              setDiscountCalc(res.data.responseData[0].discount);
              setCouponCodeMessage("Your Coupon Code applied Successfully !");
            } else {
              setIsQuantityDiscount(true);
              setQuantityCalc(res.data?.responseData[0]);
              if (count <= res.data?.responseData[0].numberOfFreeCount) {
                setCount(res.data?.responseData[0].numberOfFreeCount);
              }
              setCouponCodeMessage(`Your Coupon Code applied Successfully !. You Got ${res.data.responseData[0].numberOfFreeCount} Quantity Free upon using the ${res.data.responseData[0]?.couponCodeName} `);
            }
          }
          else {
            setCouponCodeMessage(res.data.responseData[0]?.message)
          }
          setAppliedCoupon(res.data.responseData[0]);
        }
        else {
          setCouponCodeMessage("Invalid Coupon Code");
        }
      }
    })
  }

  const togglePopover = () => {
    setCouponCode("");
    setCouponCodeMessage("");
    setDiscountCalc(null);
    automaticUpdateCouponExpiry();
    getAvailableCouponCode();
    setPopoverOpen(!popoverOpen);
  };

  const unsecuredCopyToClipboard = (text: any) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false) }, 1000);
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }
    document.body.removeChild(textArea);
  }


  const copyHandler = (index: number) => {
    let content = availbleCoupon[index]?.offerCode;
    setValidateOfferCode(availbleCoupon[index]?.offerCode);
    // setDiscountCalc(availbleCoupon[index]?.discount / 100);
    if (window.isSecureContext && navigator.clipboard) {
      navigator?.clipboard?.writeText(content);
      setIsOpen(true);
      setTimeout(() => { setIsOpen(false) }, 2000);
    } else {
      unsecuredCopyToClipboard(content);
    }
  };

  const deleteCouponCode = () => {
    setDisableCouponText(false);
    setCouponCode("");
    setCouponCodeMessage("");
    setDiscountCalc(null);
    setQuantityCalc(null);
    setIsQuantityDiscount(false);
    setAppliedCoupon({});
  }

  const automaticUpdateCouponExpiry = () => {
    CommonService.putWithQueryParam("CouponCode", "UpdateCouponCodeExpired", "toDate", moment.utc().format("YYYY-MM-DD HH:mm:ss")).then(res => {
      if (res.status === 200) {
      }
    })
  }

  const getAvailableCouponCode = () => {
    const availableData = {
      EncryptedUserId: userId,
      getDate: moment.utc().format("YYYY-MM-DD HH:mm:ss")
    }
    CommonService.post("CouponCode", "GetAvailableCouponCodeByUser", availableData).then(res => {
      if (res.status === 200) {
        setAvailbaleCoupon(res.data.responseData);
      }
    }).catch(e => console.log(e));
  }

  const calculatePrice = (menuDetails, count, discountCalc = null, quantitydiscountCalc: any) => {
    if (!menuDetails?.[0]?.amount) return '$ 0.00';

    const basePrice = menuDetails[0].amount;
    const taxRate = 8.25 / 100;

    if (discountCalc) {
      const discountedPrice = basePrice * count * (1 - discountCalc);
      const tax = calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc);
      return `$ ${(discountedPrice + Number(tax)).toFixed(2)}`;
    }

    if (quantitydiscountCalc) {
      if (count === quantitydiscountCalc?.numberOfFreeCount) {
        return 'FREE';
      }
      const payableCount = count - quantitydiscountCalc?.numberOfFreeCount;
      const subtotal = basePrice * payableCount;
      const tax = calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) as any;
      return `$ ${(subtotal + Number(tax)).toFixed(2)}`;
    }
    const subtotal = basePrice * count;
    const tax = calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) as any;
    return `$ ${(subtotal + Number(tax)).toFixed(2)}`;
  };

  const calculateTax = (menuDetails, count, discountCalc = null, quantitydiscountCalc: any) => {
    if (!menuDetails?.[0]?.amount) return '0.00';

    const basePrice = menuDetails[0].amount;
    const taxRate = 8.25 / 100;

    if (discountCalc) {
      const discountedPrice = basePrice * count * (1 - discountCalc);
      return (discountedPrice * taxRate).toFixed(2);
    }

    if (quantitydiscountCalc) {
      if (count === quantitydiscountCalc?.numberOfFreeCount) {
        return 'FREE';
      }
      const payableCount = count - quantitydiscountCalc?.numberOfFreeCount;
      const subtotal = basePrice * payableCount;
      return (subtotal * taxRate).toFixed(2);
    }

    return (basePrice * count * taxRate).toFixed(2);
  };

  const cardIcons = {
    visa: <i className="card-icon fab fa-cc-visa"></i>,
    mastercard: <i className="card-icon fab fa-cc-mastercard"></i>,
    amex: <i className="card-icon fab fa-cc-amex"></i>,
    discover: <i className="card-icon fab fa-cc-discover"></i>,
    jcb: <i className="card-icon fab fa-cc-jcb"></i>,
    diners: <i className="card-icon fab fa-cc-diners-club"></i>,
    default: <i className="card-icon fas fa-credit-card"></i>
  };

  const CardIcon = ({ cardBrand }) => {
    return cardIcons[cardBrand?.toLowerCase()] || cardIcons.default;
  };

  return (
    <Container>
      {showPaymentElement &&
        <Modal className='payment-modal' backdrop="static" isOpen={showPaymentElement} toggle={handlePaymentClose} centered size='lg'>
          <ModalHeader className='text-end' toggle={handlePaymentClose}>
            Bill Total : {` ${calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc)}`}
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-sm-12 col-lg-3">
                <aside className="sidebar-payment">
                  <nav className="nav-payment">
                    <ul>
                      <li className={selectedMethod == paymentMethodData[0]?.encryptedId ? "active" : ""} onClick={() => setSelectedMethod(paymentMethodData[0]?.encryptedId)}><i className='fa fa-thumbs-up'></i> Credit or Debit Card</li>
                      {/* <div className="text-center col-12">
                        <span className='text-muted line-or'>Other</span>
                        <span className='line-or-line'></span>
                      </div>
                      <div className='mb-1'></div>
                      <li
                        className={selectedMethod === paymentMethodData[1]?.encryptedId ? "active" : ""}
                        onClick={() => {
                          CreatePaymentLog("User chose PayPal for Payment!", OrderStatus.PaymentInitidated, paymentMethodData[1]?.encryptedId);
                          setSelectedMethod(paymentMethodData[1]?.encryptedId);
                        }}
                      >
                        <i className='bx bxl-paypal'></i> Paypal
                      </li>                      {/* <div className='mb-1'></div> */}
                      {/* <li className={selectedMethod == 3 ? "active" : ""} onClick={() => setSelectedMethod(3)}><i className='fa-brands fa-google-pay' style={{ fontSize: '24px', marginTop: '1px' }}></i>Google Pay or Apple Pay</li> */}
                    </ul>
                  </nav>
                </aside>
              </div>
              <div className="col-sm-12 col-lg-9 payment-model">
                {selectedMethod === paymentMethodData[0]?.encryptedId && (
                  <>
                    {showSaveCardPopup && (
                      <>
                        <h5 className='mt-3'>Payment Options</h5>
                        {cardDetails?.length > 0 && cardDetails?.map((card, index) => {
                          return (
                            <div key={index} className="mt-2 pt-2 border rounded">
                              <label className="d-flex align-items-center">
                                <Radio
                                  name="selectedCard"
                                  value={index}
                                  checked={selectedCardIndex === index}
                                  onChange={() => { setSelectedCardIndex(index); setIsExistingCard(true) }}
                                  style={{ color: selectedCardIndex === index ? '#E75605' : '#8F9193' }} />
                                <div>
                                  <p className="d-flex justify-content-center mb-1">
                                    <strong>Card Details:</strong> xxxx xxxx xxxx {card.cardLast4}
                                    <CardIcon cardBrand={card.cardBrand} />
                                  </p>
                                  <p className="mb-1">
                                    <strong>Expiry Date:</strong> {card.cardExpMonth}/{card.cardExpYear}
                                  </p>
                                </div>
                              </label>
                            </div>
                          );
                        })}
                        <div className="mt-2 pt-2 border rounded">
                          <label className="d-flex align-items-center">
                            <Radio
                              name="selectedCard"
                              value="newCard"
                              checked={selectedCardIndex === 'newCard'}
                              onChange={() => { setSelectedCardIndex('newCard'); }}
                              style={{ color: selectedCardIndex === 'newCard' ? '#E75605' : '#8F9193' }}
                            />
                            <div>
                              <p className="mb-1">
                                <strong> Pay with saving a new Card</strong>
                              </p>
                            </div>
                          </label>
                        </div>
                        <div className="mt-2 pt-2 border rounded">
                          <label className="d-flex align-items-center">
                            <Radio
                              name="selectedCard"
                              value="noSaveCard"
                              checked={selectedCardIndex === 'noSaveCard'}
                              onChange={() => { setSelectedCardIndex('noSaveCard'); }}
                              style={{ color: selectedCardIndex === 'noSaveCard' ? '#E75605' : '#8F9193' }}
                            />
                            <div>
                              <p className="mb-1">
                                <strong> Pay without saving a Card</strong>
                              </p>
                            </div>
                          </label>
                        </div>
                        <div className="d-flex justify-content-md-end justify-content-center mt-3">
                          <Button
                            onClick={(e) => {
                              payNow();
                            }} className='ms-2 cm-submit-button'
                            type="submit"
                          > Pay now
                          </Button>
                        </div>
                      </>
                    )}
                    {showStripeElement && (
                      <Elements stripe={stripePromise} options={{ clientSecret }}>
                        <StripePayment
                          menuName={menuDetails[0]?.menuName}
                          setIsPaymentOpen={setIsPaymentOpen}
                          setStripePromise={setStripePromise}
                          isPaymentStart={isPaymentStart}
                          setPaymentStart={setPaymentStart}
                          restaurantId={restaurentid}
                          createPaymentLogs={CreatePaymentLog}
                          callBack={processOrder}
                          amount={parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", ""))}
                          loginId={tokendata?.LoginId}
                          isSetupIntent={isSetupIntent}
                          isExistingCard={isExistingCard}
                          clientSecret={clientSecret}
                        />
                      </Elements>
                    )}
                  </>
                )}
                {selectedMethod == paymentMethodData[1]?.encryptedId &&
                  <PaypalPayment clientId={clientId} callBack={processOrder} amount={parseFloat(calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc).replace("$ ", ""))} createPaymentLog={CreatePaymentLog} />
                }
                {/* {selectedMethod == 3 &&
                  <ApplePayPayment stripeKey={paymentKey} menuName={menuDetails[0]?.menuName} amount={menuDetails[0]?.amount * count} />
              } */}
              </div>
            </div>
          </ModalBody>
        </Modal>}
      <Loader open={(isPaymentStart?.paymentProcess || isPaymentStart?.orderCreation) && isPaymentOpen} />
      <Row className='p-lg-5' style={{ opacity: (isPaymentStart?.paymentProcess || isPaymentStart?.orderCreation) ? "0.7" : "1" }}>
        <Col lg={12} md={12} sm={12} xs={12}>
          <Card style={{ borderRadius: "10px", boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}>
            <CardBody>
              <p style={{ fontSize: '20px', fontWeight: 'bolder', textAlign: 'center' }}>Order Summary</p>
              <Row>
                {/* <Col md={8}> */}
                {menuDetails.map((val, i) => (
                  <div className="single_menu">
                    <Row>
                      <Col lg={3} md={12} sm={12} xs={12}>
                        <img src={`${HelperConstant.image_cdn_Url}/${val.menuUploadFilePath}`} alt="order" className='order-img' onDoubleClick={handleImagePopup} />
                      </Col>
                      <Col lg={5} md={12} sm={12} xs={12} className="menu_content">
                        <h4><span>${(val.amount).toFixed(2)}</span>{val.menuName} <br />
                          <p style={{ fontSize: "11px" }}>{val.description}</p></h4>
                        <Row>
                          <Col lg={8} md={8}>
                            <h3 style={{ color: '#393a3bcc', fontSize: '15px' }}>{val.cityName}, {val.stateName}</h3>
                            <h3 style={{ color: '#393a3bcc', fontSize: '15px' }}>{val.countryName} - {val.zipCodeName}</h3>
                          </Col>
                          <Col lg={4} md={4}>
                            <h3 style={{ color: '#393A3B', fontSize: '13px', whiteSpace: "nowrap" }}>Pickup Date & Time</h3>
                            <h3 className="primary-color" style={{ fontSize: '12px', whiteSpace: "nowrap" }}>{isDeliveryDate}</h3>
                            <h3 className="primary-color" style={{ fontSize: '12px', whiteSpace: "nowrap" }}>{val?.deliveryTime}</h3>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={4} md={8}>
                        <Card style={{ backgroundColor: '#F1F1F1', borderRadius: "5px" }}>
                          <CardBody>
                            {quantitydiscountCalc != null &&
                              <Row style={{ textAlign: "left" }} className='mb-1'>
                                {count != quantitydiscountCalc?.numberOfFreeCount &&
                                  <Col md={6} sm={6} xs={6}>
                                    <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Quantity</h3>
                                  </Col>
                                }
                                {count == quantitydiscountCalc?.numberOfFreeCount &&
                                  <Col md={8} sm={8} xs={8}>
                                    <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Quantity</h3>
                                  </Col>
                                }
                                {count == quantitydiscountCalc?.numberOfFreeCount ?
                                  <Col md={4} sm={4} xs={4}>
                                    <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>FREE</h3>
                                  </Col> :
                                  <Col md={6} sm={6} xs={6}>
                                    <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>{quantitydiscountCalc?.numberOfFreeCount} FREE + {count - quantitydiscountCalc?.numberOfFreeCount} * {menuDetails[0]?.amount}</h3>
                                  </Col>
                                }
                                {/* <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>{count} * {menuDetails[0]?.amount}</h3>
                                </Col> */}
                              </Row>
                            }
                            {quantitydiscountCalc == null &&
                              <Row style={{ textAlign: "left" }} className='mb-1'>
                                <Col md={8} sm={8} xs={8}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Quantity</h3>
                                </Col>
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>{count} * {menuDetails[0]?.amount}</h3>
                                </Col>
                              </Row>
                            }
                            <Row className='mb-2'>
                              <Col md={8} sm={8} xs={8}>
                                <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Subtotal</h3>
                              </Col>
                              {quantitydiscountCalc == null &&
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>$ {(menuDetails[0]?.amount * count).toFixed(2)}</h3>
                                </Col>}
                              {quantitydiscountCalc != null && count != quantitydiscountCalc?.numberOfFreeCount &&
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>$ {(menuDetails[0]?.amount * (count - quantitydiscountCalc?.numberOfFreeCount)).toFixed(2)}</h3>
                                </Col>}
                              {quantitydiscountCalc != null && count == quantitydiscountCalc?.numberOfFreeCount &&
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>FREE</h3>
                                </Col>}
                            </Row>
                            {discountCalc != null &&
                              <Row className='mb-2'>
                                <Col md={8} sm={8} xs={8}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Discount (-)</h3>
                                </Col>
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>$ {((menuDetails[0]?.amount * count) * (discountCalc)).toFixed(2)}</h3>
                                </Col>
                              </Row>}

                            {discountCalc != null ?
                              <Row className='mb-2'>
                                <Col md={8} sm={8} xs={8}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Total</h3>
                                </Col>
                                <Col md={4} sm={4} xs={4}>
                                  <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>$ {((menuDetails[0]?.amount * count) - ((menuDetails[0]?.amount * count) * (discountCalc))).toFixed(2)}</h3>
                                </Col>
                              </Row>
                              : ""}

                            <Row style={{ borderBottom: "1px solid #e2e2e2", textAlign: "left" }} className='mb-3'>
                              <Col md={8} sm={8} xs={8}>
                                <h3 style={{ color: '#8A8C8E', fontSize: '15px' }}>Sales Tax</h3>
                              </Col>
                              <Col md={4} sm={4} xs={4}>
                                <h3 style={{
                                  color: calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) === 'FREE' ? '#8A8C8E' : '#393A3B',
                                  fontSize: calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) === 'FREE' ? '15px' : '17px'
                                }}>
                                  {calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) === 'FREE' ? calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc) : `$ ${calculateTax(menuDetails, count, discountCalc, quantitydiscountCalc)}`}
                                </h3>
                              </Col>
                            </Row>
                            <Row style={{ textAlign: "left" }}>
                              <Col md={8} sm={8} xs={8}>
                                <h3 style={{ color: '#393A3B', fontSize: '17px' }}>Grand Total</h3>
                              </Col>
                              <Col md={4} sm={4} xs={4}>
                                <h3 style={{ color: '#393A3B', fontSize: '17px' }}>{` ${calculatePrice(menuDetails, count, discountCalc, quantitydiscountCalc)}`}</h3>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      {/* {(appliedCoupon === validMessage) &&
                        <><label className="dd_selling-price">Offer </label>
                          <label className="price"> - ({appliedCoupon?.offerCode})</label> &nbsp;&nbsp;
                          <span style={{ position: "absolute" }} />
                          <i className='fa fa-trash' onClick={() => { deleteCouponCode() }}></i>
                        </>

                      } */}
                      <Row>
                        <Col lg={8} md={8} sm={12} xs={12} className='coupon-col'>
                          <TextField type="number" size='small' label="Coupon Code" variant="outlined" value={couponCode}
                            inputProps={{
                              maxLength: HelperConstant.couponCodeLimit,
                            }}
                            disabled={disableCouponText}
                            sx={{
                              marginRight: "20px"
                            }}
                            onChange={(e) => {
                              automaticUpdateCouponExpiry();
                              setIsApplied(false);
                              const inputValue = e.target.value;
                              if (inputValue.length <= HelperConstant.couponCodeLimit) {
                                setCouponCode(inputValue);
                              }
                            }} />
                          {(couponCode !== "" && couponCodeMessage) ?
                            <span className={`valid-msg ${couponCodeMessage == "Your Coupon Code applied Successfully !" || couponCodeMessage.includes("Your Coupon Code applied Successfully ! You got") ? "text-success" : "text-danger"} `}>{couponCodeMessage}</span> : ""}

                          {(couponCode !== "" && (couponCodeMessage != null))
                            ?
                            <><>{isApplied ?
                              <i className='fa fa-trash dlt-icon' onClick={() => { deleteCouponCode() }}></i> :
                              <Button color="success" className="text-center coupon-btn" outline onClick={() => checkValidReferralCode()} size="small">Apply</Button>}</></>
                            :
                            null
                          }
                          <span
                            id="PopoverLegacy"
                            onClick={togglePopover}
                            className='avl-coupon'

                          >
                            Available Coupon Code
                          </span>
                          <Popover
                            placement="bottom-start"
                            target="PopoverLegacy"
                            trigger="legacy"
                            isOpen={popoverOpen}
                            toggle={togglePopover}
                          >
                            <div className="popover-scroll-container">
                              {availbleCoupon.length > 0 ? (
                                <>
                                  {availbleCoupon.map((item, index) => (
                                    <p className='cc-tip' key={index}>
                                      {item?.offerCode} - {item?.couponName}
                                      <i
                                        className='mx-2 font-size-18 cursor-pointer bxs-copy-alt bx'
                                        onClick={() => copyHandler(index)}
                                      ></i>
                                    </p>
                                  ))}
                                </>
                              ) : (
                                <p className='cc-tip'>No Coupons available!</p>
                              )}
                            </div>
                          </Popover>
                          {isOpen ?
                            <span className="coupon-badge"> Copied!</span> : null}

                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                          <Row className="align-items-end">
                            <Col xs={12} className="d-flex count">
                              <i className={`fa fa-minus ${count == 1 && 'disabled-i'}`}
                                onClick={() => count == 1 ? null : setCount(count - 1)}></i>
                              <span className="mx-2" style={{ fontSize: '15px', fontWeight: 'bold' }}>{count}</span>
                              <i className={`fa fa-plus ${count === menuDetails[0]?.remainingCount || count === menuDetails[0].quantity && 'disabled-i'}`}
                                onClick={() => count === menuDetails[0]?.remainingCount ? setIsOrderCountWarning(true) : count === menuDetails[0].quantity ? null : onAddIconClick()}></i>
                              <h3 className="ms-2 primary-color" style={{ fontSize: '15px', whiteSpace: "nowrap" }}>Quantity</h3>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Modal isOpen={isImagePopupOpen} toggle={toggleImagePopup} centered size='md'>
                        <ModalBody >
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <img src={`${HelperConstant.image_cdn_Url}/${val.menuUploadFilePath}`} alt="order" className='menuimg' onClick={handleImageClose} />
                          </Col>
                        </ModalBody>
                      </Modal>
                    </Row>
                    {isOrderCountWarning && <p>{count === menuDetails[0]?.remainingCount && (
                      <div className='quantity-error'>
                        <i className="fas fa-info-circle"></i>{" "}The order limit for this menu has been reached for today! Only {menuDetails[0].remainingCount} item is still available!
                      </div>
                    )}</p>}

                  </div>
                ))}
              </Row>
              <Row>
                <div className="modal-body">
                  <form>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: "-60px" }}>
                      <Button
                        onClick={onCancelClick} disabled={disabled} className='ms-2 cm-cancel-button btn btn-secondary'
                        type="button"
                      >Back
                      </Button>
                      <Button
                        onClick={(e) => {
                          e.preventDefault();
                          paymentTypeToggle();
                        }} disabled={submitDisabled} className='ms-2 cm-submit-button'
                        type="submit"
                      >Submit Order
                      </Button>
                    </div>
                    <Loader open={loader}></Loader>
                  </form>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row >
      <CustomToaster message={"This card is already saved!"} color={"text-warning"} toast={toast} setToast={setToast} path={""} />
    </Container >
  );
};

export default CourseMenu;
